

export class APIResponse {
  constructor(status, data) {
    this.status = status;
    this.data = data;
    this.successful = [200, 201, 204].includes(this.status);
  }
}